import { ECypherType, EInfoMessageType, TCypher } from "../../../types"
import { IoMdDownload } from 'react-icons/io';
import { saveAs } from 'file-saver';

import './pdfDownload.scss'
import { useAction, useAppState } from "../../../hooks";
import { getCypherPDF } from "../../../api";

type PdfDownloadProps = {
    cypher: TCypher
}

export const PDFDownload = ({ cypher }: PdfDownloadProps) => {
    const { state } = useAppState()
    const { setInfoMessageAction } = useAction()

    if (!cypher.hasPdf || cypher.type === ECypherType.FINISH) return <></>

    function b64toFile(b64Data: string, filename: string, contentType: string) {
        var sliceSize = 512;
        console.log(b64Data)
        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);
            var byteNumbers = new Array(slice.length);

            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        var file = new File(byteArrays, filename, { type: contentType });
        return file;
    }

    const downloadCypherPdfClick = () => {
        if (state?.token) {
            getCypherPDF({ token: state.token, id: cypher.Id}).then(
                res => {
                    if (res.cypherPdf) {
                        saveAs(b64toFile(res.cypherPdf, `${cypher.name}.pdf`, "application/pdf"));
                    } else if (res.errorMessage) {
                        console.log('ERROR')
                        console.log(res.errorMessage)
                        setInfoMessageAction({ type: EInfoMessageType.ERROR, message: res.errorMessage, timeout: 20 })
                    }                    
                }
            )            
        }
    }

    return (
        <div className='pdfDownload' onClick={downloadCypherPdfClick}>
            <IoMdDownload /> Stáhnout zadání šifry
        </div>
        )
}